import config from 'services/table/const';
import Action from './action';

let table = { ...config };

table.url = '/partner';
table.filter = {type: 'customer'}
table.columns = {
  name: {
    title: 'Customer',
    sortable: true,
    width: 150,
    component: (row) => {
      return (
        <div className="table-col row">
          <div className='col-8'>
            <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
              {row?.name}
            </div>
            <small className="info text-uppercase">
              {row?.company_name}
            </small>
          </div>
          <div className='col-2 align-self-center text-end'>
            <span
              className='badge bg-info-lt ms-auto'
            >
              {row?.entities}
            </span>
          </div>
        </div>
      )
    },
  },
  pic_name: {
    title: 'Contact Person',
    sortable: false,
    width: 100,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">   {row?.pic_name}
          </div>
          <small className="info text-uppercase">{row?.pic_phone}</small>
        </div>
      );
    },
  },
  pic_email: {
    title: 'PIC Email',
    sortable: false,
    width: 100,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-9 text-uppercase">{row?.pic_email }</div>
        </div>
      );
    },
  },
  finance_name: {
    title: 'Finance',
    sortable: false,
    width: 100,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">   {row?.finance_name || '-'}
          </div>
          <small className="info text-uppercase">{row?.finance_phone}</small>
        </div>
      );
    },
  },
  finance_email: {
    title: 'Finance Email',
    sortable: false,
    width: 100,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-9">{row?.finance_emails ? row?.finance_emails?.join('\r \n'): '-'}</div>
        </div>
      );
    },
  },
  ae_name: {
    title: 'AE',
    sortable: false,
    width: 100,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">{row?.ae_name || '-'}
          </div>
          <small className="info text-uppercase">{row?.ae_email || ''}</small>
        </div>
      );
    },
  },
  is_send_invoice: {
    title: 'Dokumen Receivable',
    sortable: false,
    width: 80,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-9">{row?.is_send_invoice ? 'Dikirim': 'Tidak Dikirim'}</div>
        </div>
      );
    },
  },
  action: {
    title: '',
    width: 70,
    class: 'text-end',
    component: (row) => {
      return <Action data={row} />;
    },
  },
};

export default table;
